import store from './store.js';
import { find, findLast, padStart } from "./utility.js";

export function normalizeLeftTimestamp(timestamp) {
  return normalizeTimestamp(find, timestamp);
}

export function normalizeRightTimestamp(timestamp) {
  return normalizeTimestamp(findLast, timestamp);
}

export function normalizeTimestamp(findFunc, timestamp) {
  let segments = getTimeSegments();
  let segment = findFunc(segments, segment => {
    return (
      (timestamp + segment.timestampOffset) >= segment.normalized_startTime &&
      (timestamp + segment.timestampOffset) <= segment.normalized_endTime
    )
  });

  if (segment) {
    return timestamp + segment.timestampOffset;
  }
  else {
    // If the clock has ever jumped forward then 'timestamp' might not fall within any of the timesegments.
    // In those cases, find the most recent segment whose wallclock-end occurred before 'timestamp', then use that segment's normalized end time.
    // For example, if the clock jumped ahead from 1:00pm to 3:00pm, and we are asked for the monotonic timestamp for 2:00pm, we'll just return the monotonic time for 3:00pm.
    let segment = segments.findLast(segment => {
      let segmentWallClockEnd = segment.normalized_endTime - segment.timestampOffset;
      return segmentWallClockEnd < timestamp;
    });
    return segment.normalized_endTime;
  }
}

export function findTimeSegment(normalizedTimestamp) {
  // Special case for negative timestamps - just use the first timesegment.
  if (normalizedTimestamp < 0)
    return getTimeSegments()[0];

  let segment = findLast(getTimeSegments(), segment => {
    return normalizedTimestamp >= segment.normalized_startTime
  });
  console.assert(segment != null);
  return segment;
}

export function denormalizeTimestamp(normalizedTimestamp, segment) {
  if (normalizedTimestamp == null)
    return null;
  
  if (segment == null)
    segment = findTimeSegment(normalizedTimestamp);

  if (segment)
    return normalizedTimestamp - (segment.timestampOffset);
  else
    return null;
}

export function formatLongTimestamp(zonedDate) {
  let days = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"];
  let months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
  
  let hours = zonedDate.getUTCHours();
  let hours12 = (hours) ? (hours <= 12 ? hours : hours - 12) : 12;
  let meridiem = (hours < 12) ? " AM" : " PM";
  let timePart = `${padStart(hours12, 2, "0")}:${padStart(zonedDate.getUTCMinutes(), 2, "0")}:${padStart(zonedDate.getUTCSeconds(), 2, "0")}${meridiem}`;
  let datePart = `${zonedDate.getUTCFullYear()} ${days[zonedDate.getUTCDay()]} ${months[zonedDate.getUTCMonth()]} ${zonedDate.getUTCDate()},`;

  return datePart + " " + timePart;
}

function getTimeSegments() {
  // A bug in previous versions led to the timeSegments.lastRecordNumber to become zeroed out after trimming old records from the database.
  // These invalid time segments would then cause the records records date picker to incorrectly apply the selected date-from value.
  // There should no longer be any records falling within the invalid time segments, so the filter operation below removes them from consideration
  // and prevents the date picker bug.
  let segments = store.sessions[0].system.timeSegments.value;
  return segments.filter(segment => segment.lastRecordNumber > 0);
}